/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import awsConfig from '../../../Configuration/environment-config';
import { signedFetch } from '../../Utilities/utils';
import { v4 as uuidv4 } from 'uuid';

export default class ConversationsApiService {
  static async fetchJobManagersEndPoint(jobId: string, orgId: string, userId?: string) {
    try {
      const endpointConfig = awsConfig.aws_cloud_logic_custom.find((api) => api.name === 'jobManagers');

      if (!endpointConfig?.endpoint) {
        console.error('Endpoint configuration not found');
        return { success: false, errors: [{ message: 'Endpoint not found' }] };
      }

      const endpointUrl = `${endpointConfig.endpoint}`;

      const response = await signedFetch({
        method: 'POST',
        url: endpointUrl,
        body: { jobId, orgId },
        requestId: uuidv4(),
        userId,
      });

      return {
        data: response?.data ?? null,
        errors: response?.errors ?? [],
      };
    } catch (e: any) {
      return { data: null, errors: e.errors };
    }
  }
}
